<template>
  <div class="InformationList">
    <div @click="toInfor(item.id)" class="list_card" data-aos="fade-up" v-for="(item,index) in InformationDatas" :key="index" >
      <!-- :to=item.link -->
      <div class="left-img" >
        <div class="bg" :style="'background-image:url('+item.titleimage+')'"></div>
        <!-- <img class="bg" :src=item.url alt=""> -->
      </div>
      <div class="right-text">
        <div class="text_title">{{item.title}}</div>
        <p class="text_font">
          {{item.text}}
        </p>
        <div class="text_tag">
          <p class="tag_data">{{item.newstime}}</p>
          <!-- <div class="tag_tag">{{item.tag}}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.InformationList {
  .list_card {
    margin: 0 10%;
    display: flex;
    padding: 30px 0;
    border-bottom: 1px solid #999;
    cursor: pointer;
    .left-img {
      
      .bg{
        //background: url("../../../assets/images/aboutUs/InformationCard-1.png") no-repeat center;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        /*width: 480px;
        height: 270px;*/
        
      }
    }
    .right-text {
      padding-left: 3.75rem;
      .text_title{
        font-size: 2.5rem;
        color: #12294f;
        margin-bottom: 20px;
      }
      .text_font{
        overflow: hidden;
        height: 57px;
      }
      .text_tag{
        display: flex;
        .tag_data{
          margin: 0;
        }
        .tag_tag{
          color: #005bab;
          margin-left: 50px;
        }
      }
    }
  }
}
</style>
<script>
export default {
  name: "InformationList",
  props:{
    InformationDatas:[],
  },
  data() {
    return {
      
    }
  },
  mounted () {
  },
  methods:{
    toInfor(id){
      this.$router.push({
        path:"/information-details/"+id
      })
    },
  },
}
</script>
